// Theme: core-protocol
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'core-protocol',
  name: 'Core Protocol',
  tagline: 'PROTOCOL',
  description: 'Painel de progressao funcional. Clareza, consistencia e leitura rapida.',
  category: 'system-core',
  tier: 'common',
  basePrice: 0,
  swatches: ['#08110d', '#2ae6b7', '#18181b', '#f4f4f5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.25)',
      '--shadow-card-active': '0 12px 28px rgba(0, 0, 0, 0.32)'
    },
    shellClasses: 'font-sans theme-core-protocol'
  },
  colorVars: {
    '--accent': '#2ae6b7',
    '--accent-foreground': '#08110d',
    '--background': '#08110d',
    '--border': '#27272a',
    '--card': '#18181b',
    '--card-border-active': 'rgba(42, 230, 183, 0.22)',
    '--card-completed': '#102219',
    '--card-foreground': '#f4f4f5',
    '--card-glow': 'rgba(42, 230, 183, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#f4f4f5',
    '--hold-fill': '#2ae6b7',
    '--input': '#27272a',
    '--modal-bg': '#08110d',
    '--modal-border': '#27272a',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.25)',
    '--muted': '#141417',
    '--muted-foreground': '#a1a1aa',
    '--nav-active': '#2ae6b7',
    '--nav-bg': '#101114',
    '--popover': '#18181b',
    '--popover-foreground': '#f4f4f5',
    '--premium': '#a78bfa',
    '--primary': '#2ae6b7',
    '--primary-foreground': '#08110d',
    '--rarity-epic': '#a78bfa',
    '--rarity-legendary': '#fbbf24',
    '--rarity-rare': '#60a5fa',
    '--rarity-secret': '#f87171',
    '--ring': '#2ae6b7',
    '--secondary': '#1f1f22',
    '--secondary-foreground': '#f4f4f5',
    '--streak': '#22c55e',
    '--success': '#22c55e',
    '--success-foreground': '#08110d',
    '--xp': '#2ae6b7',
    '--xp-bg': '#0a1a17'
  },
  resolvedVars: {
    '--accent': '#2ae6b7',
    '--accent-foreground': '#08110d',
    '--accent-foreground-hsl': '153 36% 5%',
    '--accent-foreground-oklch': 'from #08110d l c h',
    '--accent-hsl': '165 79% 53%',
    '--accent-oklch': 'from #2ae6b7 l c h',
    '--background': '#08110d',
    '--background-hsl': '153 36% 5%',
    '--background-oklch': 'from #08110d l c h',
    '--border': '#27272a',
    '--border-hsl': '240 4% 16%',
    '--border-oklch': 'from #27272a l c h',
    '--border-w': '1px',
    '--card': '#18181b',
    '--card-border-active': 'rgba(42, 230, 183, 0.22)',
    '--card-completed': '#102219',
    '--card-completed-hsl': '150 36% 10%',
    '--card-completed-oklch': 'from #102219 l c h',
    '--card-foreground': '#f4f4f5',
    '--card-foreground-hsl': '240 5% 96%',
    '--card-foreground-oklch': 'from #f4f4f5 l c h',
    '--card-glow': 'rgba(42, 230, 183, 0.06)',
    '--card-hsl': '240 6% 10%',
    '--card-oklch': 'from #18181b l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#f4f4f5',
    '--foreground-hsl': '240 5% 96%',
    '--foreground-oklch': 'from #f4f4f5 l c h',
    '--hold-fill': '#2ae6b7',
    '--hold-fill-hsl': '165 79% 53%',
    '--hold-fill-oklch': 'from #2ae6b7 l c h',
    '--input': '#27272a',
    '--input-hsl': '240 4% 16%',
    '--input-oklch': 'from #27272a l c h',
    '--modal-bg': '#08110d',
    '--modal-bg-hsl': '153 36% 5%',
    '--modal-bg-oklch': 'from #08110d l c h',
    '--modal-border': '#27272a',
    '--modal-border-hsl': '240 4% 16%',
    '--modal-border-oklch': 'from #27272a l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.25)',
    '--muted': '#141417',
    '--muted-foreground': '#a1a1aa',
    '--muted-foreground-hsl': '240 5% 65%',
    '--muted-foreground-oklch': 'from #a1a1aa l c h',
    '--muted-hsl': '240 7% 8%',
    '--muted-oklch': 'from #141417 l c h',
    '--nav-active': '#2ae6b7',
    '--nav-active-hsl': '165 79% 53%',
    '--nav-active-oklch': 'from #2ae6b7 l c h',
    '--nav-bg': '#101114',
    '--nav-bg-hsl': '225 11% 7%',
    '--nav-bg-oklch': 'from #101114 l c h',
    '--popover': '#18181b',
    '--popover-foreground': '#f4f4f5',
    '--popover-foreground-hsl': '240 5% 96%',
    '--popover-foreground-oklch': 'from #f4f4f5 l c h',
    '--popover-hsl': '240 6% 10%',
    '--popover-oklch': 'from #18181b l c h',
    '--premium': '#a78bfa',
    '--premium-hsl': '255 92% 76%',
    '--premium-oklch': 'from #a78bfa l c h',
    '--primary': '#2ae6b7',
    '--primary-foreground': '#08110d',
    '--primary-foreground-hsl': '153 36% 5%',
    '--primary-foreground-oklch': 'from #08110d l c h',
    '--primary-hsl': '165 79% 53%',
    '--primary-oklch': 'from #2ae6b7 l c h',
    '--radius': '8px',
    '--rarity-epic': '#a78bfa',
    '--rarity-epic-hsl': '255 92% 76%',
    '--rarity-epic-oklch': 'from #a78bfa l c h',
    '--rarity-legendary': '#fbbf24',
    '--rarity-legendary-hsl': '43 96% 56%',
    '--rarity-legendary-oklch': 'from #fbbf24 l c h',
    '--rarity-rare': '#60a5fa',
    '--rarity-rare-hsl': '213 94% 68%',
    '--rarity-rare-oklch': 'from #60a5fa l c h',
    '--rarity-secret': '#f87171',
    '--rarity-secret-hsl': '0 91% 71%',
    '--rarity-secret-oklch': 'from #f87171 l c h',
    '--ring': '#2ae6b7',
    '--ring-hsl': '165 79% 53%',
    '--ring-oklch': 'from #2ae6b7 l c h',
    '--secondary': '#1f1f22',
    '--secondary-foreground': '#f4f4f5',
    '--secondary-foreground-hsl': '240 5% 96%',
    '--secondary-foreground-oklch': 'from #f4f4f5 l c h',
    '--secondary-hsl': '240 5% 13%',
    '--secondary-oklch': 'from #1f1f22 l c h',
    '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.25)',
    '--shadow-card-active': '0 12px 28px rgba(0, 0, 0, 0.32)',
    '--streak': '#22c55e',
    '--streak-hsl': '142 71% 45%',
    '--streak-oklch': 'from #22c55e l c h',
    '--success': '#22c55e',
    '--success-foreground': '#08110d',
    '--success-foreground-hsl': '153 36% 5%',
    '--success-foreground-oklch': 'from #08110d l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(165 79% 53% / 0.15)',
    '--xp': '#2ae6b7',
    '--xp-bg': '#0a1a17',
    '--xp-bg-hsl': '169 44% 7%',
    '--xp-bg-oklch': 'from #0a1a17 l c h',
    '--xp-hsl': '165 79% 53%',
    '--xp-oklch': 'from #2ae6b7 l c h'
  }
}
